package es.subastia.domain.model

enum class AuctionTypeDomainModel(val id: String, val text: String, val boeCode: String) {
    Inmuebles("inmuebles", "Inmuebles", "I"),
    Vehiculos("vehiculos", "Vehículos", "V"),
    Otros("otros", "Otros bienes muebles", "M");

    companion object {
        fun fromString(text: String): AuctionTypeDomainModel? {
            return entries.find { it.text.equals(text, ignoreCase = true) || it.id.equals(text, ignoreCase = true) }
        }
    }
}
